import React, { useRef } from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import Icon from 'flow/components/ui-components/Icon';
import IconButton from 'flow/components/ui-components/IconButton';
import Button from '../ui-components/Button';
import UserAvatar from '../ui-components/UserAvatar';
import DEFAULT_AVATAR_SVG from 'images/ic_telavox_default_avatar_60.svg';

interface Props {
    avatarSource: string;
    setAvatarSource: (source: string) => void;
    setInterimAvatarFile: (source: File) => void;
}

const ContactEditAvatar = ({
    avatarSource,
    setAvatarSource,
    setInterimAvatarFile,
}: Props) => {
    const { i18next } = useAppContext();
    const fileUpload = useRef(null);

    const extractSource = (attachment: File) => {
        if (attachment) {
            const reader = new FileReader();
            reader.readAsDataURL(attachment);

            reader.onloadend = () => {
                setAvatarSource(reader.result.toString());
            };
        }
    };

    return (
        <div>
            <div className="relative flex shrink-0">
                <div className="flex grow items-center gap-6">
                    <UserAvatar size="large" src={avatarSource} />
                    <div className="flex gap-2">
                        <Button
                            className="min-w-[60px]"
                            onClick={() => fileUpload.current?.click()}
                        >
                            {i18next.t('Edit.image')}
                        </Button>
                        {avatarSource &&
                            avatarSource !== DEFAULT_AVATAR_SVG && (
                                <IconButton
                                    aria-label={i18next.t('Delete.Button.Text')}
                                    onClick={() =>
                                        setAvatarSource(DEFAULT_AVATAR_SVG)
                                    }
                                >
                                    <Icon iconKey="delete" />
                                </IconButton>
                            )}
                    </div>
                </div>
            </div>
            <input
                ref={fileUpload}
                className="hidden"
                type="file"
                onChange={({ target }) => {
                    extractSource(target?.files[0]);
                    setInterimAvatarFile(target?.files[0]);
                    target.value = null;
                }}
                accept="image/*"
            />
        </div>
    );
};

export default ContactEditAvatar;
